import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';

import { ErrorBoundary } from '../components/error-boundary';
import { PageContainer } from '../components/layout/page-container';
import { PostDetail } from '../features/community/post-detail';
import { postQuery } from '../features/community/use-posts';
import { commentsQuery } from '../features/comments/use-comments';
import { hasSession } from '../lib/auth';
import { orNotFound } from '../lib/or-not-found';
import { pageHead } from '../lib/seo';
import { canonical } from '../lib/site';

export const Route = createFileRoute('/posts/$id/')({
  loader: async ({ params: { id }, context: { queryClient } }) => {
    // 서버는 비로그인 키로 채운다. 브라우저 이동은 화면과 같은 키(hasSession). 없는 글 404.
    const post = await orNotFound(queryClient.ensureQueryData(postQuery(id, await hasSession())));
    // 댓글은 실패해도 글을 막지 않는다.
    await queryClient.ensureQueryData(commentsQuery({ kind: 'post', id })).catch(() => undefined);
    return { title: post.title };
  },
  head: ({ loaderData, params }) =>
    loaderData
      ? pageHead({
          title: loaderData.title,
          description: loaderData.title,
          url: canonical(`/posts/${params.id}`),
          type: 'article',
        })
      : {},
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  return (
    <PageContainer>
      <ErrorBoundary resetKey={id} fallback={() => <p className="text-sm text-text-muted">글을 찾을 수 없어요. 삭제됐을 수 있어요.</p>}>
        <Suspense fallback={<p className="text-sm text-text-muted">불러오는 중…</p>}>
          <PostDetail id={id} />
        </Suspense>
      </ErrorBoundary>
    </PageContainer>
  );
}
